/* import __COLOCATED_TEMPLATE__ from './priority.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { TABLE_ROW_TRACKING_SECTION } from '../table-row';
import type ConversationsTableActions from 'embercom/objects/inbox/conversations-table-actions';
import type CommandKService from 'embercom/services/command-k';
import type Session from 'embercom/services/session';

interface Args {
  conversationEntry: ConversationTableEntry;
  conversationsTableActions: ConversationsTableActions;
}

interface Signature {
  Args: Args;
}

export default class Priority extends Component<Signature> {
  @service declare commandK: CommandKService;
  @service declare session: Session;

  @action async onChangePriority() {
    // When the multi-level flag is on, the click opens the Command+K picker
    // and the chosen level is forwarded to `setPriorityLevel`. Otherwise we
    // keep the legacy binary toggle behaviour for the star icon.
    if (this.session.workspace.isFeatureEnabled('team-inbox-priority-levels')) {
      this.commandK.registerAndShow({
        actionID: 'set-priority-level',
        onSelect: (priority: number) => {
          this.args.conversationsTableActions.setPriorityLevel(
            this.args.conversationEntry,
            priority,
            TABLE_ROW_TRACKING_SECTION,
          );
        },
      });
      return;
    }

    this.args.conversationsTableActions.togglePriority(
      this.args.conversationEntry,
      TABLE_ROW_TRACKING_SECTION,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::Priority': typeof Priority;
    'inbox2/conversations-table/table-cells/priority': typeof Priority;
  }
}
